<template>
  <app-content class="h-panel">
    <div class="h-panel-bar"><span class="h-panel-title">发票勾选</span></div>
    <div class="h-panel-body" style="padding: 40px 20px;">
      <div class="external-tip">
        <i class="h-icon-info external-tip-icon"></i>
        <div class="external-tip-title">发票勾选</div>
        <div class="external-tip-desc">{{ cloudMessage }}</div>
        <div class="margin-top">
          <Button color="primary" icon="fa fa-check-square-o" @click="$router.push({name: 'InputInvoice'})">去进项发票勾选</Button>
        </div>
      </div>
    </div>
  </app-content>
</template>

<script>
export default {
  name: 'InvoiceCheckSelect',
  data() {
    return {
      cloudMessage: '发票勾选认证需电子税局授权同步，本地提供手工勾选台账。'
    }
  },
  mounted() {
    this.$api.tax.cloud.status().then(({data}) => {
      if (data && data.message) {
        this.cloudMessage = data.enabled && data.provider ? `${data.message}（服务商：${data.provider}）` : data.message;
      }
    }).catch(() => {
    });
  }
}
</script>

<style lang="less" scoped>
.external-tip {
  margin: 40px auto;
  max-width: 640px;
  text-align: center;
  padding: 40px 30px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  background: #fafafa;
}

.external-tip-icon {
  font-size: 48px;
  color: #2db7f5;
}

.external-tip-title {
  font-size: 18px;
  font-weight: bold;
  margin: 16px 0 10px;
}

.external-tip-desc {
  color: #808695;
  font-size: 14px;
  line-height: 22px;
}
</style>
